import { snackStore } from 'stores';

import { SNACK_SCOPES } from '../../../constants';

let snackId: void | string;

function show() {
  clean();

  const snackParams = {
    i18key: 'registration.payment.canceled',
    payload: { closeButton: true },
  };

  snackId = snackStore.error(snackParams, { scope: SNACK_SCOPES.payment });
}

function clean() {
  snackId && snackStore.removeValue(snackId);
}

const cancelSnack = {
  show,
  clean,
};

export { cancelSnack };
